const quickLinks = [
  { label: "全网热搜榜", href: "#hot" },
  { label: "事件排行", href: "#event" },
  { label: "分类热榜", href: "#category" },
  { label: "瓜点解析", href: "#topics" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

const catLinks = ["娱乐瓜", "社会热点", "科技热闻", "生活潮流", "校园青春", "民生热议"];

export default function SiteFooter() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-extrabold tracking-wide">吃瓜热门</span>
                <span className="mt-1 text-[11px] text-background-300">CHIGUA HOT LIST</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">
              实时汇总全网热搜、事件排行与热点排行，按热度或时间一键切换。打开第一页，就能锁定当下最值得关注的网上热瓜。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <a
                href="mailto:hello@chiguahot.example"
                className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-400"
              >
                <i className="ri-mail-line mr-1"></i>
                hello@chiguahot.example
              </a>
              <a
                href="#top"
                className="whitespace-nowrap rounded-full border border-background-300/40 px-4 py-2 text-xs font-medium text-background-200 transition-colors hover:border-accent-400"
              >
                <i className="ri-arrow-up-line mr-1"></i>
                回到顶部
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-bold tracking-wide text-background-50">站内导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-background-300">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="inline-flex items-center gap-1.5 transition-colors hover:text-primary-300">
                    <i className="ri-arrow-right-s-line text-accent-400"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-bold tracking-wide text-background-50">分类热榜</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {catLinks.map((c) => (
                <a
                  key={c}
                  href="#category"
                  className="whitespace-nowrap rounded-full border border-background-300/30 px-3 py-1.5 text-xs text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  {c}
                </a>
              ))}
            </div>
            <p className="mt-6 text-xs leading-relaxed text-background-400">
              吃瓜热门仅聚合公开可讨论的网络信息与热度排行，榜单反映热度不构成立场倾向，请理性围观、勿以瓜代谣。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/20 pt-6 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜热门 · 今日热点聚合门户</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-flashlight-fill text-accent-400"></i>
            实时更新中，愿每个热点都不被错过
          </p>
        </div>
      </div>
    </footer>
  );
}